import styled from '@emotion/styled';

const Form = styled.form`
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
`;

(Form as any).defaultProps = {
  noValidate: true,
};
export default Form;
